import React, { useMemo } from 'react'
import { Box, Typography, Divider, Paper, Grid, Button, TextField } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useForm, Controller } from "react-hook-form";
import { submitQuery } from 'services/support';

const HelpAndSupport = () => {

  const defaultFormFields = useMemo(() => ({
    subject: '',
    message: '',
  }),[]);
  const { handleSubmit, control, formState: { errors }, reset } = useForm({
    mode: 'onTouched',
    defaultValues: {...defaultFormFields}
  });

  const { enqueueSnackbar } = useSnackbar();


  const onSubmit = (data) => {
    submitQuery({...data, userType: 'VENDOR'}).then(({response, error}) => {
        if(response){
          enqueueSnackbar(response?.message || 'We have received your query' , {variant: 'success'});
          reset({...defaultFormFields});
        } else {
          enqueueSnackbar((response?.message || error), {variant: 'error'});
        }
      });
  }

  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
      <Typography component="h2" variant="h6" color="secondary" gutterBottom sx={{mb: 1}}>
        Help and Support
      </Typography>
      <Divider />
      <Box component="form" noValidate  sx={{ mt: 2 }} onSubmit={handleSubmit(onSubmit)}>
        <Grid container columnSpacing={4} rowSpacing={2} direction={{md: "row-reverse"}}>
          <Grid item xs={12} sm={12} md={6} xl={6} lg={6}>
            <img
              src='/assets/images/support.png'
              alt="Refer and Earn"
              loading="lazy"
              style={{width: '100%'}}
            />
          </Grid>
          <Grid container item xs={12} sm={12} md={6} xl={6} lg={6} justifyContent="space-around">
              <Grid item xs={10} sm={10} md={10} lg={10} >
                <Controller
                  control={control}
                  name="subject"
                  id="subject"
                  rules={{ required: "Enter subject title" }}
                  render={({field}) => (
                    <TextField
                      {...field}
                      margin="normal"
                      label="Subject"
                      required
                      error={!!errors?.subject}
                      size="small"
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={10} sm={10} md={10} lg={10} >
                <Controller
                  control={control}
                  name="message"
                  id="message"
                  rules={{ required: "Enter query" }}
                  render={({field}) => (
                    <TextField
                      {...field}
                      margin="normal"
                      placeholder="Query/Issue"
                      multiline
                      required
                      error={!!errors?.message}
                      size="small"
                      fullWidth
                      rows={10}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={10} sm={10} md={10} lg={10} sx={{mt: 2}} textAlign="center">
                  <Button variant='contained' type='submit' sx={{textTransform: 'none'}}>Submit Query</Button>
              </Grid>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}
 
export default React.memo(HelpAndSupport);
